import React, { useEffect, useState } from "react";
import DataViewPage from "../../controls/DataViewPage";
import { useLocation, useNavigate } from "react-router-dom";
import ReportViewPage from "../../controls/ReportViewPage";
import Input from "../../controls/Input";
import Pagination from "../../controls/Pagination";
import CustomTable from "../../controls/CustomTable";
import { fetchOutStandingLedgerByCustomerID } from "../../../api/CustomerApi";
import { useSelector } from "react-redux";
import { selectRegistration } from "../../../redux/slices/userSlice";
import { toast } from "react-toastify";
import { exportToFile } from "../../controls/DataExporter";
import Icon from "../../../assets/icons/Icon";
const CustomerOutStandingLedger = () => {
   const navigate=useNavigate();
   const location=useLocation();
   const customer=location?.state?.data;
   console.log("customer",customer);
   const [transactionNo,setTransactionNo]=useState("");
   const [fromDate,setFromDate]=useState("");
   const [toDate,setToDate]=useState("");
   const [loading,setLoading]=useState(false);
   const [data,setData]=useState([]);
   const registration=useSelector(selectRegistration);
   const [from,setFrom]=useState(0);
   const [size,setSize]=useState(25);
     const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
   const [totalCount, setTotalCount] = useState(0);


 const filterComponents = [
  <Input 
    key="transactionNo"
    label={"Transaction No"} 
    value={transactionNo} 
    onChange={(e) => setTransactionNo(e.target.value)}
  />,
  <Input 
    key="fromDate"
    label={"From Date"} 
    value={fromDate} 
    onChange={(e) => setFromDate(e.target.value)} 
    type={"date"}
  />,
  <Input 
    key="toDate"
    label={"To Date"} 
    value={toDate} 
    onChange={(e) => setToDate(e.target.value)} 
    type={"date"}
  />
];
 useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);
 const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    setFrom((newPage - 1) * rowsPerPage);
  };

  const handleRowsPerPageChange = (newSize) => {
    setRowsPerPage(newSize);
    setSize(newSize);
    setCurrentPage(1);
    setFrom(0);
  };
  
const fetchData=async()=>{
    setLoading(true);
    try{
    const response=await fetchOutStandingLedgerByCustomerID(from,size,customer.key,registration.key,fromDate,toDate,transactionNo);
    if(response.code=="0"){
    setData(response?.searchResult);
    }else{
        setData([]);
        toast.error("Failed to fetch data");

    }
    setTotalCount(response.totalItemsCount);
    console.log("response",response);
}catch(error){
    toast.error(error?.message || "Failed to fetch data");

}
finally{
    setLoading(false);
}
}

  const columns = [

    { field: "TransactionNo", headerName: "Transaction No" },
       { field: "TransactionDate", headerName: "Date" },
       {field:"CustomerName",headerName:"Customer Name"},
          { field: "TransactionType", headerName: "Type" },
          {field:"Amount",headerName:"Amount",type:"currency",showTotal:true},
          {field:"PaidAmount",headerName:"Paid Amount",type:"currency",showTotal:true},
{field:"BalanceAmount",headerName:"Balance",type:"currency",showTotal:true}

   
  ];

    const handleExport = async (type) => {
   const response=await fetchOutStandingLedgerByCustomerID(from,10000,customer.key,registration.key,fromDate,toDate,transactionNo);
    const exportColumns=[
         { field: "TransactionNo", header: "Transaction No" },
       { field: "TransactionDate", header: "Date" },
          { field: "TransactionType", header: "Type" },
          {field:"Amount",header:"Amount",type:"currency"},
          {field:"PaidAmount",header:"Paid Amount",type:"currency"},
{field:"BalanceAmount",header:"Balance",type:"currency"}
    ]
       try {
           console.log("data",data);
           if (data && data.length > 0) {
             await exportToFile({
               data: response.searchResult,
               columns: exportColumns,
               fileType: type, // 'PDF' or 'CSV'
               title: "CustomerOutstandingledger",
               landscape: true
             });
           } else {
             toast.warning("No data available to export");
           }
      } catch (error) {
        toast.error(`Export failed: ${error.message}`);
      }
    };

const reportConfig = {
    title: `${customer?.FirstName || ''} ${customer?.LastName || ''}`.trim() || 'Customer Outstanding Ledger',
    iconType: "alert-circle"
};


    return (
        <ReportViewPage
        title={customer?.FirstName+" " + customer?.LastName}
        reportConfig={reportConfig}
        subText={
  <div className="flex gap-2">
    {customer?.PhoneNo && (
      <>
        <div className="w-5">
          <Icon type="phone" />
        </div>
        {customer.PhoneNo}
      </>
    )}
    {customer?.EmailID && (
      <>
        <div className="w-5">
          <Icon type="email" />
        </div>
        {customer.EmailID}
      </>
    )}
  </div>
}
        filters={filterComponents}
        hideFooter={false}
        hideApplyFilterButton={false}
        loading={loading}
        footer={
                  <Pagination
                    count={totalCount}
                    page={currentPage}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                }
        onExport={handleExport}
        onRefresh={()=>{fetchData()}}
        onApplyFilters={fetchData}
      >
    
        <CustomTable
          columns={columns}
          loading={loading}
          rows={data}
          loadingRows={25}
          showTextOnRows={data.length > 0 ? null : "No data found!"}
        />
      </ReportViewPage>
    );
};

export default CustomerOutStandingLedger;